import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteLocation = {
  name: "deleteLocation" as const,
  input: z.object({ locationId: zExt.objectId() }),
  output: z.null(),
};
